import { Pipe, PipeTransform } from '@angular/core';
import { particulierStepValidator, proStepValidator } from '@components/form/components/form-layout-1/config';
import { UserType } from '@components/form/components/form-layout-1/model';
import { ValueType } from '@shared/components/form-item/model';

@Pipe({
  name: 'isStepVisible',
  standalone: true,
})
export class IsStepVisiblePipe implements PipeTransform {
  transform(step: number, form: Record<string, ValueType>, userType: UserType): boolean {
    const validator = userType === 'professionnel' ? proStepValidator : particulierStepValidator;
    for (const prop of validator[step]!) {
      if (!form[prop]) {
        return false;
      }
    }
    return true;
  }
}
